export const COUNTRY_PHONE_NUMBER = [
  // { name: "Australia", code: "61", label: "+61", flag: "🇦🇺" },
  { name: "Indonesia", code: "62", label: "+62", flag: "🇮🇩" },
];
